import React from 'react';
import { TouchableOpacity, View } from 'react-native'
import { colors } from "../const"
import styles from '../styles'

export const CircleButton = ({ component, ...others }) => (
    <TouchableOpacity
        style={{ cursor:"pointer", padding: 15}}
        activeOpacity={0.8}
        {...others}
    >
        {component}
    </TouchableOpacity>
)

export const SquareButton = (props) => (
    <TouchableOpacity
        {...props}
        style={[styles.squareButton, styles.bgBlue]}
    >
        {props.component}
    </TouchableOpacity>
)

export const SquareButtonRed = (props) => (
    <TouchableOpacity
        {...props}
        style={[styles.squareButton, styles.bgAlert]}
    >
        {props.component}
    </TouchableOpacity>
)

export const Touchable = (props) => (
    <TouchableOpacity
        {...props}
        activeOpacity={0.8}
    >
        {props.component}
    </TouchableOpacity>
)

export const RadioButton = ({ onPress, selected, size, color }) => {
    size = size ? size : 20
    color = color ? color : colors.indigo
    return (
    <TouchableOpacity 
        style={{ borderWidth: 2, borderColor: color, borderRadius: size, height: size, width: size, alignItems: 'center', justifyContent: 'center' }}
        onPress={onPress ? onPress : () => null}
        activeOpacity={0.8}
    >
        { selected ? <View style={{ backgroundColor: color, width: size*0.6, height: size*0.6, borderRadius: size*0.8 }}/> : null}
    </TouchableOpacity>
)}

